import React from 'react'
import { Button } from './Button'

const ButtonGreen = (props) => {
  return(
    <Button
      {...props}
      background='#007F7D'
    />
  )
}

export { ButtonGreen }